import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { FiEdit, FiTrash2, FiX, FiCheck } from "react-icons/fi";
import "./EventListing.css";

const API = `${process.env.REACT_APP_API_URL || "http://localhost:5000"}/admin/eventlisting`;

export default function EventListing() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [eventRequests, setEventRequests] = useState([]);


  const fetchEvents = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API}/events`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to fetch events");
      setEvents(data);
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchEventRequests = async () => {
    try {
      const res = await fetch(`${API}/event-request`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to fetch requests");
      setEventRequests(data);
    } catch (e) {
      console.error("Error fetching requests:", e.message);
    }
  };

  useEffect(() => {
    fetchEvents();
    fetchEventRequests();
  }, []);

  // ---------------- ADD NEW EVENT -----------------
  const handleAdd = async () => {
    let ticketSections = [{ category: "", price: "", count: "" }];

    const renderTicketInputs = () =>
      ticketSections
        .map(
          (t, idx) => `
        <div class="ticket-row" style="display:flex; gap:3px; margin-bottom:8px;">
            <input id="cat-${idx}" class="swal2-input" placeholder="Category" style="width:200px; margin:0;" value="${t.category || ''}">
            <input id="price-${idx}" class="swal2-input" placeholder="Price" type="number" style="width:100px; margin:0;" value="${t.price || ''}">
            <input id="count-${idx}" class="swal2-input" placeholder="Count" type="number" style="width:100px; margin:0;" value="${t.count || ''}">
        </div>`
        )
        .join("");

    await Swal.fire({
      title: "List an Event",
      html: `
        <div style="display:flex; flex-direction:column; gap:12px; align-items:center; justify-content: center; width:100%; max-width:400px; margin:0 auto;">
            <input id="title" class="swal2-input" placeholder="Event Title" style="width:100%;">
            <textarea id="desc" class="swal2-textarea" placeholder="Description" style="width:100%;"></textarea>

            <!-- Image Upload -->
            <div id="file-upload-wrapper" 
              style="
                  display: flex; 
                  flex-direction: column;
                  align-items: center; 
                  justify-content: center; 
                  width: 100%; 
                  max-width: 400px;
                  margin: 0 auto;
              ">
              <!-- Hidden actual input -->
              <input type="file" id="image" accept="image/*" style="display: none;" />

              <!-- Styled label acts as button -->
              <label for="image" 
                    style="
                        display: flex; 
                        align-items: center; 
                        justify-content: center; 
                        width: 100%; 
                        height: 50px; 
                        border: 2px dashed #4338ca; 
                        border-radius: 12px; 
                        cursor: pointer; 
                        color: #3b82f6;
                        font-weight: 600;
                        font-size: 16px;
                        text-align: center;
                        transition: background 0.2s, color 0.2s;
                    "
                    onmouseover="this.style.background='#4338ca'; this.style.color='#fff';" 
                    onmouseout="this.style.background=''; this.style.color='#3b82f6';">
                  Click or drag file to upload
              </label>
            </div>

            <!-- Subtopic: Ticket Information -->
            <h2 style="font-size:16px; font-weight:600; color:#374151; margin-top:12px; text-align:center;">
            Ticket Information
            </h2>

            <div id="tickets">${renderTicketInputs()}</div>
            <button id="add-ticket" type="button" class="swal2-styled" style="
                display:flex; 
                align-items:center; 
                justify-content:center; 
                width:100%; 
                height:50px; 
                border:2px dashed #4338ca; 
                border-radius:12px; 
                cursor:pointer; 
                color:#3b82f6;
                font-weight:600;
                transition: background 0.2s, color 0.2s;
                text-align:center;
            " 
            onmouseover="this.style.background='#4338ca'; this.style.color='#fff';" 
            onmouseout="this.style.background=''; this.style.color='#3b82f6';">
            + Add Ticket</button>
        </div>
        `,
      didOpen: () => {
        const addBtn = document.getElementById("add-ticket");
        const ticketsDiv = document.getElementById("tickets");

        addBtn.addEventListener("click", () => {
          const idx = ticketSections.length;
          ticketSections.push({ category: "", price: "", count: "" });

          // Create a new ticket row dynamically
          const row = document.createElement("div");
          row.className = "ticket-row";
          row.style = "display:flex; gap:3px; margin-bottom:8px;";
          row.innerHTML = `
            <input id="cat-${idx}" class="swal2-input" placeholder="Category" style="width:200px; margin:0;">
            <input id="price-${idx}" class="swal2-input" placeholder="Price" type="number" style="width:100px; margin:0;">
            <input id="count-${idx}" class="swal2-input" placeholder="Count" type="number" style="width:100px; margin:0;">
            `;
          ticketsDiv.appendChild(row);
        });
      },
      showCancelButton: true,
      confirmButtonText: "Save Event",
      customClass: {
        confirmButton: "custom-swal-confirm",
        cancelButton: "custom-swal-cancel",
      },
      preConfirm: () => {
        const title = document.getElementById("title").value.trim();
        const description = document.getElementById("desc").value.trim();

        const tickets = ticketSections.map((_, idx) => ({
          category: document.getElementById(`cat-${idx}`).value.trim(),
          price: parseFloat(document.getElementById(`price-${idx}`).value),
          count: parseInt(document.getElementById(`count-${idx}`).value),
        }));

        if (!title || tickets.some(t => !t.category || isNaN(t.price) || isNaN(t.count))) {
          Swal.showValidationMessage("Please fill all fields before saving.");
          return false;
        }

        return { title, description, tickets };
      },
    }).then(async (result) => {
      if (!result.value) return;
      const formValues = result.value;

      const formData = new FormData();
      formData.append("title", formValues.title);
      formData.append("description", formValues.description);
      formData.append("tickets", JSON.stringify(formValues.tickets));

      const fileInput = document.getElementById("image");
      if (fileInput && fileInput.files[0]) {
        formData.append("image", fileInput.files[0]);
      }

      try {
        const res = await fetch(`${API}/events`, {
          method: "POST",
          body: formData,
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message);
        Swal.fire({ title: "Success", text: "Event listed successfully", icon: "success", timer: 1200, showConfirmButton: false });
        fetchEvents();
      } catch (e) {
        Swal.fire("Error", e.message, "error");
      }
    });
  };

  // ---------------- EDIT EVENT -----------------
  const handleEdit = async (event) => {
    const parsedTickets = Array.isArray(event.tickets)
      ? event.tickets
      : JSON.parse(event.tickets || "[]");

    let ticketSections = [...parsedTickets];

    const renderTicketInputs = () =>
      ticketSections
        .map(
          (t, idx) => `
        <div style="display:flex; gap:3px; margin-bottom:8px;">
            <input id="cat-${idx}" class="swal2-input" placeholder="Category" style="width:200px; margin:0;" value="${t.category}">
            <input id="price-${idx}" class="swal2-input" placeholder="Price" type="number" style="width:100px; margin:0;" value="${t.price}">
            <input id="count-${idx}" class="swal2-input" placeholder="Count" type="number" style="width:100px; margin:0;" value="${t.count}">
        </div>`
        )
        .join("");

    const showModal = async () => {
      const { value: formValues } = await Swal.fire({
        title: "Update Event",
        html: `
            <div style="display:flex; flex-direction:column; gap:10px; align-items:center; justify-content: center; width:100%; max-width:400px; margin:0 auto;">
            <input id="title" class="swal2-input" placeholder="Event Title" style="width:100%;" value="${event.title}">
            <textarea id="desc" class="swal2-textarea" placeholder="Description" style="width:100%;">${event.description || ""}</textarea>
            
            <!-- Subtopic: Ticket Information -->
            <h2 style="font-size:16px; font-weight:600; color:#374151; margin-top:12px; text-align:center;">
            Ticket Information
            </h2>

            <div id="tickets">${renderTicketInputs()}</div>
            <button id="add-ticket" class="swal2-styled" style="
            display:flex; 
                align-items:center; 
                justify-content:center; 
                width:100%; 
                height:50px; 
                border:2px dashed #4338ca; 
                border-radius:12px; 
                cursor:pointer; 
                color:#3b82f6;
                font-weight:600;
                transition: background 0.2s, color 0.2s;
                text-align:center;
            " 
            onmouseover="this.style.background='#4338ca'; this.style.color='#fff';" 
            onmouseout="this.style.background=''; this.style.color='#3b82f6';">
            + Add Ticket</button>
            </div>
        `,
        didOpen: () => {
          const addBtn = document.getElementById("add-ticket");
          if (addBtn) {
            addBtn.addEventListener("click", () => {
              ticketSections.push({ category: "", price: "", count: "" });
              Swal.update({
                html: Swal.getHtmlContainer().innerHTML.replace(
                  /<div id="tickets">.*<\/div>/s,
                  `<div id="tickets">${renderTicketInputs()}</div>`
                ),
              });
              showModal(); // reopen modal with new inputs & button
            });
          }
        },
        showCancelButton: true,
        confirmButtonText: "Save Changes",
        customClass: {
          confirmButton: "custom-swal-confirm",
          cancelButton: "custom-swal-cancel",
        },
        preConfirm: () => {
          const title = document.getElementById("title").value;
          const description = document.getElementById("desc").value;
          const tickets = ticketSections.map((_, idx) => ({
            category: document.getElementById(`cat-${idx}`).value,
            price: parseFloat(document.getElementById(`price-${idx}`).value),
            count: parseInt(document.getElementById(`count-${idx}`).value),
          }));
          if (!title || tickets.some(t => !t.category || !t.price || !t.count)) {
            Swal.showValidationMessage("Please fill all fields");
            return;
          }
          return { title, description, tickets };
        },
      });

      if (!formValues) return null;
      return formValues;
    };

    const formValues = await showModal();
    if (!formValues) return;

    try {
      const res = await fetch(`${API}/events/${event.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formValues),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      Swal.fire({ title: "Success", text: "Event updated successfully", icon: "success", timer: 1200, showConfirmButton: false });
      fetchEvents();
    } catch (e) {
      Swal.fire("Error", e.message, "error");
    }
  };

  // ---------------- DELETE EVENT -----------------
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Delete Event?",
      text: "This will permanently remove the event.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
      customClass: {
        confirmButton: "custom-swal-confirm",
        cancelButton: "custom-swal-cancel",
      },
    }).then(async (res) => {
      if (res.isConfirmed) {
        const r = await fetch(`${API}/events/${id}`, { method: "DELETE" });
        const d = await r.json();
        if (r.ok) {
          Swal.fire({ title: "Deleted!", text: "Event removed.", icon: "success", timer: 1200, showConfirmButton: false });
          fetchEvents();
        } else {
          Swal.fire("Error", d.message, "error");
        }
      }
    });
  };

  const handleRequestAction = async (id, approve) => {
    try {
      const admin_id = JSON.parse(localStorage.getItem("user"))?.id;
      const res = await fetch(`${API}/event-request/${id}/approve`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ admin_id, approve }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      Swal.fire({
        title: approve ? "Approved!" : "Rejected!",
        text: `Request ${approve ? "approved" : "rejected"} successfully`,
        icon: approve ? "success" : "error",
        timer: 1200,
        showConfirmButton: false,
      });
      fetchEventRequests(); // refresh requests table
    } catch (e) {
      Swal.fire("Error", e.message, "error");
    }
  };


  // ---------------- RENDER -----------------
  if (loading) return <p>Loading events…</p>;
  if (err) return <p style={{ color: "crimson" }}>{err}</p>;

  return (
    <div className="wd-page">
      <div className="wd-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 className="wd-title">Event Management</h2>
        <button className="btn ghost" onClick={handleAdd}>+ List Event</button>
      </div>

      <section className="card table-card">
        <table className="table">
          <thead>
            <tr>
              <th>Post</th>
              <th>Title</th>
              <th>Description</th>
              <th>Tickets</th>
              <th>Date of published</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {events.map(ev => (
              <tr key={ev.id}>
                <td>
                  {ev.image ? (
                    <img
                      src={ev.image}
                      alt={ev.title}
                      style={{ width: "80px", height: "60px", objectFit: "cover", borderRadius: "8px" }}
                    />
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>{ev.title}</td>
                <td className="muted">{ev.description || "—"}</td>
                <td className="muted">
                  {(Array.isArray(ev.tickets)
                    ? ev.tickets
                    : JSON.parse(ev.tickets || "[]")
                  ).map((t, idx) => (
                    <div key={idx}>
                      {t.category} - ${t.price} (<strong>{t.count} left</strong>)
                    </div>
                  ))}
                </td>
                <td className="muted">{new Date(ev.created_at).toLocaleString()}</td>
                <td>
                  <FiEdit
                    style={{ cursor: "pointer", color: "#3b82f6", marginRight: 12 }}
                    size={18}
                    onClick={() => handleEdit(ev)}
                    title="Update"
                  />
                  <FiTrash2
                    style={{ cursor: "pointer", color: "#ef4444" }}
                    size={18}
                    onClick={() => handleDelete(ev.id)}
                    title="Delete"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {events.length === 0 && <p className="dots">No events listed yet.</p>}
      </section>
      <h2 className="wd-title">Event Requests</h2>
      <section className="card table-card" style={{ marginTop: 40 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Date Submitted</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {eventRequests.map(req => (
              <tr key={req.id}>
                <td>{req.user_name}</td>
                <td>{req.user_email}</td>
                <td>{req.role_name}</td>
                <td>{req.status_name}</td>
                <td>{new Date(req.created_at).toLocaleString()}</td>
                <td>
                  <button
                    style={{ backgroundColor: "#22c55e", color: "#fff", border: "none", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", marginBottom: "6px", transition: "background 0.2s" }}
                    title="Approve"
                    onClick={() => handleRequestAction(req.id, true)}
                  >
                    <FiCheck />
                  </button>
                  <button
                    style={{ backgroundColor: "#c52222ff", color: "#fff", border: "none", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", marginRight: "6px", transition: "background 0.2s" }}
                    title="Reject"
                    onClick={() => handleRequestAction(req.id, false)}
                  >
                    <FiX />
                  </button>
                </td>
              </tr>
            ))}
            {eventRequests.length === 0 && (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>No requests found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
}
